module.exports = __webpack_public_path__ + "/login_ui/img/gr-bb62b9f78dd06f008c698d71a8a0edb2.svg";